const AuthAlertMessage = ({ children, tone = "error" }) => {
	const styles =
		tone === "warning"
		? "border-amber-200 bg-amber-50 text-amber-800"
		: "border-red-200 bg-red-50 text-red-700";

	return <div className={`rounded-2xl border p-3 text-sm ${styles}`}>{children}</div>;
};
export default AuthAlertMessage;
